<template>
  <div></div>
</template>
<script>
import { checkoutBookingForCustomer } from '@/stripe';

export default {
  async created() {
    const { bid } = this.$route.query;

    if (!bid) this.$router.push('/');

    // TODO loading spinner

    try {
      checkoutBookingForCustomer(bid);
    } catch (e) {
      this.$notify({
        type: 'error',
        title: 'Something went wrong',
        text: e
      });
    }
  }
};
</script>
